import { Component, OnInit } from '@angular/core';
//import { FormBuilder, FormControl, FormGroup,Validators } from '@angular/forms';
import { WebService } from '../services/web/web.service';
@Component({
  selector: 'app-template',
  templateUrl: './template.component.html',
  styleUrls: ['./template.component.css']
})
export class TemplateComponent implements OnInit {
  model: any = {};
  appnames;
  selectedappname;
  file:any;
  imgsrc:"";
  message; 
  messageClass;
  constructor(private httpService:WebService) {
  		this.httpService.getMethod('/menuroute/getappname').then(appdata=>{
  			this.appnames = appdata.json();
  			this.appnames = this.appnames.appnames;
  		}).catch(err=>{
  			console.log(err);
  		})

      
   }
 
  ngOnInit() {
  }
   
  onChange(e){
  	this.selectedappname = e;
  	console.log(this.selectedappname);
  	
  }
  fileChangeEvent(event:any){ 

    this.file = event.target.files[0];
    console.log(this.file.name)



    var reader = new FileReader();
     reader.readAsDataURL(event.target.files[0]); // read file as data url
     reader.onload = (e) => { // called once readAsDataURL is completed
       console.log(e)
       this.imgsrc = e.target['result']; 
       
     }
    // this.fileName =this.file.name;
    // this.imgloading = !this.imgloading;
    
   }

onCreatMenu(){
    this.httpService.uploadImage('/templateroute/createtemplate',this.file,this.model).then(templateData=>{
      console.log(templateData)
      if(templateData['success']){
        this.message = "Template cretated Succesfully";
        this.messageClass= "alert alert-success";
      }else{
        this.message = "Error to Creat Template !";
        this.messageClass="alert alert-danger";
      }
    }).catch(errTemplateData=>{
      console.log(errTemplateData)
        this.message = "Error to Creat Template !";
        this.messageClass="alert alert-danger";
    })

	}

}



// WEBPACK FOOTER //
// ./src/app/template/template.component.ts